import React from 'react';
import {Form} from '../../../components/form/Form';
import {useFormSubmit} from '../../../controllers/useSubmitForm';

export const CustomerReviewForm = props => {
  const {
    route: {params},
  } = props;
  const {row, website} = params;
  let {onSubmit} = useFormSubmit({
    uri: '/customerreviews',
    eventSourceId: 'customerreview',
  });
  return (
    <Form
      api={`/customerreviews/${row?._id}`}
      fields={{
        videoUrl: 1,
        customerName: 1,
        customerTitle: 1,
        logoUrl: 1,
        thumbnailUrl: 1,
        avatarUrl: 1,
        index: 1,
      }}
      defaultValues={{
        website,
      }}
      onSubmit={onSubmit}
      layoutFields={[
        {
          label: 'Customer Name',
          type: 'text',
          field: 'customerName',
          required: true,
        },
        {
          label: 'Customer Title',
          type: 'text',
          field: 'customerTitle',
          required: true,
        },
        {
          label: 'Video',
          type: 'file',
          storage: 's3', // for uploading file to s3
          field: 'videoUrl',
          required: true,
        },
        {
          label: 'Logo',
          type: 'file',
          field: 'logoUrl',
          required: true,
        },
        {
          label: 'Thumbnail',
          type: 'file',
          field: 'thumbnailUrl',
          required: true,
        },
        {
          label: 'Avatar',
          type: 'file',
          field: 'avatarUrl',
          required: true,
        },
        {
          label: 'Index',
          type: 'number',
          field: 'index',
        },
      ]}
      {...props}
    />
  );
};

export const AddCustomerReviewForm = props => {
  return <CustomerReviewForm header="Add Customer Review" {...props} />;
};

export const UpdateCustomerReviewForm = props => {
  return (
    <CustomerReviewForm
      mode="edit"
      header="Update Customer Review"
      {...props}
    />
  );
};
